// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-753cfdb2]{transition:var(--transition-all);fill:var(--secondary-text-icon)}.svg-up[data-v-753cfdb2]{transform:rotate(0deg)}.svg-right[data-v-753cfdb2]{transform:rotate(90deg)}.svg-down[data-v-753cfdb2]{transform:rotate(180deg)}.svg-left[data-v-753cfdb2]{transform:rotate(-90deg)}", ""]);
// Exports
module.exports = exports;
